export enum ClientApiDiagnosticEvents
{
    ClientUploadFile,
    ClientUploadFileFailure,
    ClientDownloadFile,
    ClientDownloadFileFailure,
    ClientSearchFilesByMetaData,
    ClientSearchFilesByFolderPattern,
    ClientSearchByGDrive,
}
